import { useState, useEffect } from 'react';

// Miniatura carregada pela API (as rotas de arquivos devolvem blob)
// carregar: função da apiService que recebe o caminho e devolve a resposta blob
export default function FotoMiniatura({ arquivo, label, carregar, onAbrir }) {
  const [url, setUrl]   = useState(null);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    if (!arquivo) return undefined;
    let objectUrl = null;
    let ativo = true;
    carregar(arquivo)
      .then(resp => {
        objectUrl = URL.createObjectURL(resp.data);
        if (ativo) setUrl(objectUrl);
      })
      .catch(() => ativo && setErro(true));
    return () => {
      ativo = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [arquivo, carregar]);

  return (
    <div>
      <div className="text-xs text-gray-500 mb-1">{label}</div>
      <div className="bg-gray-50 border border-gray-100 rounded aspect-video flex items-center justify-center overflow-hidden">
        {!arquivo ? (
          <span className="text-xs text-gray-400">Não registrada</span>
        ) : erro ? (
          <span className="text-xs text-red-500">Arquivo não encontrado</span>
        ) : url ? (
          <button onClick={() => onAbrir(arquivo)} className="w-full h-full" title="Abrir em tamanho real">
            <img src={url} alt={label} className="w-full h-full object-cover" />
          </button>
        ) : (
          <span className="text-xs text-gray-400">Carregando...</span>
        )}
      </div>
    </div>
  );
}
